import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { IMetric } from '@client/shared/components/metric/metric.interface';

// metric bar chart with label and amount
@Component({
  selector: 'app-metric',
  templateUrl: './metric.component.html',
  styleUrls: ['./metric.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class MetricComponent {
  @Input() metric: IMetric;
}
